import React from 'react';
import {Row, Col, FormControl, Panel, FormGroup, InputGroup, Button, HelpBlock} from 'react-bootstrap';
// css
import '../../styles/commonStyles.css';

class PanelPagamento extends React.Component {
  constructor(props) {
    super(props); 

    const { panPagamento, editMode } = this.props;

    let totale = (editMode)? panPagamento['totale']: '';
    let caparra = (editMode)? panPagamento['caparra']: '';
    let modalitaIncassoCaparra = (editMode)? panPagamento['modalitaIncassoCaparra']: '';
    let NumeroAUT = (editMode)? panPagamento['NumeroAUT']: '';
    let caparraTrattenuta = (editMode)? panPagamento['caparraTrattenuta']: '';    
    let nrRate = (editMode)? panPagamento['nrRate']: '';
    let importoPrimaRata = (editMode)? panPagamento['importoPrimaRata']: '';    
    let mesePosticipato = (editMode)? panPagamento['mesePosticipato']: '';    
    let importoSingolaRata = (editMode)? panPagamento['importoSingolaRata']: '-';

    this.state = {
      totale,
      caparra,
      modalitaIncassoCaparra,
      NumeroAUT,
      caparraTrattenuta,      
      nrRate,
      importoPrimaRata,      
      mesePosticipato,      
      importoSingolaRata,
      afterCalc: false,      
      editMode: this.props.editMode, 
    }      

    this.checkCaparra = this.checkCaparra.bind(this);
    this.validateOnChange = this.validateOnChange.bind(this);
    this.handleCaparraTrattenuta = this.handleCaparraTrattenuta.bind(this);  
    this.handleCalcola = this.handleCalcola.bind(this);
    this.handleNeedsTwoContacts = this.handleNeedsTwoContacts.bind(this);      
  }

  render() {
    const { 
      totale, nrRate, importoPrimaRata, caparra, modalitaIncassoCaparra, NumeroAUT,
      caparraTrattenuta, mesePosticipato, importoSingolaRata, afterCalc 
    } = this.state;

    let rowStyle = (afterCalc && !this.props.needsCalculation)?     
      "noNegativeMargin" : "noNegativeMargin hiddenRow";   
    
    let curMonth = new Date().getMonth()+1;  

  	return (
  		<Col xs={12}>
		    <Panel>		      
		      <Panel.Heading>Pagamento</Panel.Heading>
		      <Panel.Body>     
            <Row className="noNegativeMargin">
              <Col xs={12} lg={2}>
                <label htmlFor="totale">Totale da pagare</label>
                <FormGroup>                  
                  <InputGroup>                  
                    <FormControl 
                      id="totale" name="totale" type="text"            
                      pattern="^[0-9]+(\.[0-9]{1,2})?$" required autoComplete="off"             
                      data-caption="Totale da pagare" data-parse="number" data-separator="%%%Pagamento"                    
                      onChange={this.validateOnChange}  
                      defaultValue={totale}                                               
                    />    
                    <InputGroup.Addon>€</InputGroup.Addon>
                  </InputGroup>
                </FormGroup>     
              </Col>

              <Col xs={12} lg={3}>
                <label htmlFor="mesePosticipato">Mesi posticipo</label>
                <FormGroup>
                  <FormControl 				
                      componentClass="select" placeholder=""      						                    
                      id="mesePosticipato" name="mesePosticipato" 
                      data-caption="Mese posticipo" data-parse="select"
                      onChange={this.handleNeedsTwoContacts}
                      defaultValue={mesePosticipato}>		
                        {/* Attenzione l'ordine e la posizione contano */}
                        <option value="">Nessun posticipo</option>	                        									
                        <option value="Gennaio">Gennaio (+{(curMonth >= 1)? (12 - curMonth + 1) : (1 - curMonth)} mesi) </option>
                        <option value="Febbraio">Febbraio (+{(curMonth >= 2)? (12 - curMonth + 2) : (2 - curMonth)} mesi) </option>
                        <option value="Marzo">Marzo (+{(curMonth >= 3)? (12 - curMonth + 3) : (3 - curMonth)} mesi) </option>
                        <option value="Aprile">Aprile (+{(curMonth >= 4)? (12 - curMonth + 4) : (4 - curMonth)} mesi) </option>
                        <option value="Maggio">Maggio (+{(curMonth >= 5)? (12 - curMonth + 5) : (5 - curMonth)} mesi) </option>
                        <option value="Giugno">Giugno (+{(curMonth >= 6)? (12 - curMonth + 6) : (6 - curMonth)} mesi) </option>
                        <option value="Luglio">Luglio (+{(curMonth >= 7)? (12 - curMonth + 7) : (7 - curMonth)} mesi) </option>
                        <option value="Agosto">Agosto (+{(curMonth >= 8)? (12 - curMonth + 8) : (8 - curMonth)} mesi) </option>
                        <option value="Settembre">Settembre (+{(curMonth >= 9)? (12 - curMonth + 9) : (9 - curMonth)} mesi) </option>
                        <option value="Ottobre">Ottobre (+{(curMonth >= 10)? (12 - curMonth + 10) : (10 - curMonth)} mesi) </option>
                        <option value="Novembre">Novembre (+{(curMonth >= 11)? (12 - curMonth + 11) : (11 - curMonth)} mesi) </option>
                        <option value="Dicembre">Dicembre (+{(curMonth < 12)? (12 - curMonth) : curMonth} mesi) </option>
                  </FormControl>           
                </FormGroup>     
              </Col> 

              <Col xs={12} lg={2}>
                <label htmlFor="caparra">Caparra</label>
                <FormGroup>                  
                  <InputGroup>                  
                    <FormControl 
                      id="caparra" name="caparra"             
                      pattern="^[0-9]+(\.[0-9]{1,2})?$" type="text" autoComplete="off"           
                      required data-caption="Caparra" data-parse="number"
                      onChange={this.validateOnChange}
                      defaultValue={caparra}                      
                    />    
                    <InputGroup.Addon>€</InputGroup.Addon>
                  </InputGroup>
                </FormGroup>     
              </Col>            
                    
              <Col xs={12} lg={2}>
								<label htmlFor="modalitaIncassoCaparra">Modalit&agrave; caparra</label>
								<FormGroup>								
									<FormControl 
										componentClass="select" placeholder=""
                    onChange={this.handleCaparraTrattenuta}
										id="modalitaIncassoCaparra" name="modalitaIncassoCaparra" 
                    data-caption="Modalità caparra" data-parse="select"
                    defaultValue={modalitaIncassoCaparra}
                    required>		
                      <option value="" disabled>Scegli la modalit&agrave;</option>										
                      <option value="C">Contanti</option>
                      <option value="P">POS</option>
                      <option value="A">Assegno</option>
                      <option value="B">Bonifico</option>
                      <option value="X">Altro</option>
									</FormControl>
							  </FormGroup>
              </Col> 							      
              <Col xs={12} lg={3}>
								<label htmlFor="NumeroAUT">Numero autorizzazione</label>
                <FormControl id="NumeroAUT" name="NumeroAUT" type="text" autoComplete="off"           
                  data-caption="Numero autorizzazione" onChange={this.validateOnChange}
                  defaultValue={NumeroAUT}                      
                />    
              </Col>
            </Row>

            <Row className="noNegativeMargin">
              <Col xs={12} lg={3}>		
                <label htmlFor="caparraTrattenuta">Caparra trattenuta contanti</label>						
								<FormGroup>
                  <FormControl 
										componentClass="select" placeholder=""                    
										id="caparraTrattenuta" name="caparraTrattenuta" 
                    data-caption="Trattenimento caparra" data-parse="select"
                    defaultValue={caparraTrattenuta}
                    required>								
                      <option value="" disabled>Scegli il trattenimento</option>														
                      <option value="T">S&igrave;</option>
                      <option value="F">No</option>										
									</FormControl>           
								</FormGroup>
							</Col>   

              <Col xs={12} lg={3}>
                <label htmlFor="importoPrimaRata">Rata alla consegna</label>
                <FormGroup>                  
                  <InputGroup>                  
                    <FormControl 
                      id="importoPrimaRata" name="importoPrimaRata"             
                      pattern="^[0-9]+(\.[0-9]{1,2})?$" type="text" autoComplete="off"            
                      required data-caption="Rata alla consegna" data-parse="number"
                      onChange={this.validateOnChange}  
                      defaultValue={importoPrimaRata}                                                     
                    />    
                    <InputGroup.Addon>€</InputGroup.Addon>
                  </InputGroup>
                </FormGroup>     
              </Col>                        

              <Col xs={12} lg={3}>
                <label htmlFor="nrRate">Nr. rate</label>
                <InputGroup>
                  <FormControl 
                    id="nrRate" name="nrRate"
                    pattern="^[0-9]\d*$" type="text"        
                    required autoComplete="off"
                    onChange={this.validateOnChange}                    
                    data-caption="Nr. rate"
                    data-parse="number"   
                    defaultValue={nrRate} 
                  /> 
                  <InputGroup.Addon>rate</InputGroup.Addon>
                </InputGroup>             
              </Col>              

              <Col xs={12} lg={3}>
                <label>Campi calcolati</label>
                <Button className="btn-primary btn-outline" 
                  onClick={this.handleCalcola} block>Calcola</Button>
              </Col> 
            </Row>

            <Row className="noNegativeMargin">
              <Col xs={12}>
                <HelpBlock>
                  Premi <strong>Calcola</strong> prima di proseguire con la compilazione del modulo successivo.
                </HelpBlock>
              </Col>
            </Row>

            <Row className={rowStyle}>             
  		        <Col xs={12} lg={2}>
  		          <label htmlFor="importoSingolaRata">Singola rata</label>
  		          <FormGroup>
  		          	<InputGroup>						    	
  						      <FormControl 
  				            id="importoSingolaRata" name="importoSingolaRata"	            
  				            type="text"      
                      pattern="^[0-9]+(\.[0-9]{1,2})?$"                      
                      data-caption="Singola rata"
                      data-parse="number"
                      required                     
                      value={importoSingolaRata}
                      onChange={() => (this.setState({importoSingolaRata: importoSingolaRata}))}
  		          		/>		
  	      					<InputGroup.Addon>€</InputGroup.Addon>
  						    </InputGroup>
  		          </FormGroup>     
  		        </Col>   	      
		        </Row>
		      </Panel.Body>
		    </Panel>
		  </Col>
  	);
  }  

  // Calcola acconti e importo singola rata
  handleCalcola() {  
    // parseFloat: 200a => 200, 20a5 => 20, aaaa => NaN
    let totale = parseFloat(this.state.totale); 
    totale = (isNaN(totale))? 0 : totale; 

    let caparra = parseFloat(this.state.caparra); 
    caparra = (isNaN(caparra)? 0 : caparra);

    let importoPrimaRata = parseFloat(this.state.importoPrimaRata);
    importoPrimaRata = (isNaN(importoPrimaRata))? 0: importoPrimaRata;  
      
    let nrRate = Number(this.state.nrRate);    
            
    let singola = 0;
    if(nrRate > 0) {
      singola = (totale - caparra - importoPrimaRata) / nrRate;
    } 

    this.setState({
      afterCalc: true,              
      importoSingolaRata: singola.toFixed(2)
    });
  
    // processo di calcolo svolto, permette di inviare
    this.props.toggleNeedsCalculation(false);
  }

  checkCaparra(field) {
    if (field.name == "totale" || field.name == "caparra" || field.name == "mesePosticipato") {
      // La caparra deve essere superiore al 10% del totale
      // se i mesi posticipo sono maggiori o uguali a 4,
      // può essere nulla se "Nessun posticipo"

      let nrMeseCur = new Date().getMonth()+1; // Gennaio=0
      let nrMeseSel = (document.getElementById("mesePosticipato").selectedIndex); 
           
      if (field.name == "totale") {
        let posticipato = (Math.abs((nrMeseSel - nrMeseCur)) >= 4)? (field.value * 10)/100 : 0; 
        let caparra = document.getElementById('caparra');          

        if (caparra > 0 && caparra.value <= posticipato) {
          field.setCustomValidity('err');  
          field.classList.add('invalid-field');    
        } 
      } else 
      if (field.name == "caparra") {
        let totale = document.getElementById("totale").value;
        let posticipato = (Math.abs((nrMeseSel - nrMeseCur)) >= 4)? (totale * 10)/100 : 0;                

        if (nrMeseSel > 0 && field.value <= posticipato) {
          field.setCustomValidity('err');  
          field.classList.add('invalid-field');    
        }
      } else
      if (field.name == "mesePosticipato") {
        let totale = document.getElementById("totale").value;        
        let posticipato = (Math.abs((nrMeseSel - nrMeseCur)) >= 4)? (totale * 10)/100 : 0;         

        let caparra = document.getElementById("caparra");

        if (posticipato > 0 && caparra.value <= posticipato) {
          caparra.setCustomValidity('err');  
          caparra.classList.add('invalid-field');               
        } else {
          caparra.setCustomValidity('');
          if(caparra.classList.contains('invalid-field'))
            caparra.classList.remove('invalid-field'); 
        }
      }
    } 
  }

  validateOnChange(e) {        
    const field = e.target;
    const pattern = field.pattern;                    
    let value = field.value;

    if(!field.value.match(pattern)) {     
      field.setCustomValidity('err');  // invalida il form    
      field.classList.add('invalid-field'); 
    } else {     
      field.setCustomValidity(''); // valida il form  
      if(field.classList.contains('invalid-field'))
        field.classList.remove('invalid-field'); 
      
      this.checkCaparra(field);            
    }

    value = (value==='')? value : parseFloat(value);
    this.setState({[field.name]: value, afterCalc: null});     
  }

  handleNeedsTwoContacts(e) {   
    this.props.toggleNeedsTwoContacts(e.target.value > 1);
    // Cambia il mese posticipato, controlla caparra
    this.checkCaparra(e.target);
  }

  handleCaparraTrattenuta(e) {            
    let modCap = e.target.value;
    let capTrt = document.getElementById("caparraTrattenuta");
    capTrt.value = ((modCap == "" || modCap == "C")? "" : "F");
  }
}

export default PanelPagamento;


// WEBPACK FOOTER //
// ./src/cmp/Orders/Panels/PanelPagamento.js